/* ============================================================
   Product card 1 (jr-pcard) - quick add to cart + fly image
   Moved out of snippets/product-card-1.liquid so it loads ONCE
   (cached) instead of being printed inside every product card.
   ============================================================ */
(function () {
  if (window.__jrQuickAddBound) return;
  window.__jrQuickAddBound = true;

  var ROUTES = (window.MinimogSettings && window.MinimogSettings.routes) || {};
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var CART_ADD_URL = ROUTES.cart_add_url || ROOT + 'cart/add';
  var CART_URL = ROUTES.cart || ROOT + 'cart';

  /* ---------- Fly image preloading (fixes first-click fly) ---------- */
  var flyCache = {};
  function preloadFly(url) {
    if (!url) return Promise.resolve();
    if (flyCache[url]) return flyCache[url];
    flyCache[url] = new Promise(function (resolve) {
      var img = new Image();
      img.onload = function () {
        if (img.decode) { img.decode().then(resolve, resolve); } else { resolve(); }
      };
      img.onerror = resolve;
      img.src = url;
    });
    return flyCache[url];
  }
  // Speed: only preload fly images for cards that are on / near the screen,
  // and only after the page has finished loading (keeps bandwidth free for the first paint).
  var flyObserver = null;
  function preloadAll() {
    var buttons = document.querySelectorAll('[data-jr-quick-add][data-fly-image]');
    if (!('IntersectionObserver' in window)) {
      buttons.forEach(function (b) { preloadFly(b.getAttribute('data-fly-image')); });
      return;
    }
    if (!flyObserver) {
      flyObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          flyObserver.unobserve(entry.target);
          preloadFly(entry.target.getAttribute('data-fly-image'));
        });
      }, { rootMargin: '200px 0px' });
    }
    buttons.forEach(function (b) {
      if (b.__jrFlyObserved) return;
      b.__jrFlyObserved = true;
      flyObserver.observe(b);
    });
  }
  // Cards added later (AJAX recommendations): preload when the user reaches the card
  function preloadFromEvent(e) {
    var card = e.target.closest && e.target.closest('.jr-pcard');
    if (!card) return;
    var b = card.querySelector('[data-jr-quick-add][data-fly-image]');
    if (b) preloadFly(b.getAttribute('data-fly-image'));
  }
  document.addEventListener('pointerover', preloadFromEvent, { passive: true });
  document.addEventListener('touchstart', preloadFromEvent, { passive: true });
  function preloadWhenIdle() {
    if (window.requestIdleCallback) {
      window.requestIdleCallback(preloadAll, { timeout: 2000 });
    } else {
      setTimeout(preloadAll, 300);
    }
  }
  if (document.readyState === 'complete') {
    preloadWhenIdle();
  } else {
    window.addEventListener('load', preloadWhenIdle);
  }
  // New cards (infinite scroll / load more / filters / recommendations)
  document.addEventListener('shopify:section:load', preloadWhenIdle);
  if ('MutationObserver' in window) {
    var moTimer = null;
    new MutationObserver(function () {
      clearTimeout(moTimer);
      moTimer = setTimeout(function () { if (flyObserver) preloadAll(); }, 400);
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  // Wait for the image (max 600ms), then run the fly
  function runFly(btn) {
    if (!window.jrCartFly) return Promise.resolve();
    var url = btn.getAttribute('data-fly-image');
    var wait = new Promise(function (r) { setTimeout(r, 600); });
    return Promise.race([preloadFly(url), wait]).then(function () {
      return window.jrCartFly(btn);
    });
  }

  /* ---------- Cart ---------- */
  function getDrawer() {
    return document.querySelector('m-cart-drawer');
  }

  function getDrawerSections() {
    var cart = getDrawer();
    if (cart && typeof cart.getSectionsToRender === 'function') {
      try { return cart.getSectionsToRender() || []; } catch (e) { return []; }
    }
    return [];
  }

  function addToCart(variantId) {
    var settings = window.MinimogSettings || {};
    var sections = getDrawerSections();
    var body = { items: [{ id: Number(variantId), quantity: 1 }] };
    if (sections.length) {
      body.sections = sections.map(function (s) { return s.id; }).join(',');
      body.sections_url = window.location.pathname;
    }
    return fetch((settings.routes && settings.routes.cart_add_url) || CART_ADD_URL, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        Accept: 'application/json'
      },
      body: JSON.stringify(body)
    })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        if (data.status) {
          var err = new Error(data.description || data.message || 'Could not add to cart');
          err.data = data;
          throw err;
        }
        return { data: data, sections: sections };
      });
  }

  // Refresh drawer content in the background - drawer stays CLOSED
  function refreshDrawerSilently(result) {
    var html = result.data && result.data.sections;
    if (!html) return;
    var parser = new DOMParser();
    result.sections.forEach(function (s) {
      var markup = html[s.id];
      if (!markup) return;
      var doc = parser.parseFromString(markup, 'text/html');
      var newEl = null;
      var oldEl = null;
      if (s.selector) {
        newEl = doc.querySelector(s.selector);
        oldEl = document.querySelector(s.selector);
      }
      if (!newEl || !oldEl) {
        newEl = doc.querySelector('.shopify-section') || doc.body;
        oldEl = document.getElementById('shopify-section-' + s.id) || document.getElementById(s.id);
      }
      if (newEl && oldEl) oldEl.innerHTML = newEl.innerHTML;
    });
  }

  function updateCartCount() {
    return fetch(CART_URL + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        document.querySelectorAll('.m-cart-count-bubble, [data-cart-count]').forEach(function (b) {
          b.textContent = c.item_count;
          b.classList.toggle('m:hidden', c.item_count === 0);
        });
        var drawer = getDrawer();
        if (drawer) {
          drawer.classList.toggle('m-cart--empty', c.item_count === 0);
          var items = drawer.querySelector('m-cart-drawer-items');
          if (items) items.classList.toggle('m-cart--empty', c.item_count === 0);
        }
        return c;
      });
  }

  function handleQuickAdd(btn) {
    if (!btn || btn.getAttribute('data-loading') === 'true') return;
    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;

    var label = btn.querySelector('.jr-btn__label');
    var original = label ? label.textContent : '';
    btn.setAttribute('data-loading', 'true');
    if (label) label.textContent = 'Adding...';

    // Fly (waits for image) and add-to-cart request run side by side
    var flight = runFly(btn).catch(function () {});

    addToCart(variantId)
      .then(function (result) {
        refreshDrawerSilently(result);
        return Promise.all([flight, updateCartCount()]);
      })
      .then(function () {
        if (label) label.textContent = 'ADDED';
      })
      .catch(function (err) {
        console.error('Add to cart failed:', err.message, err.data || err);
        var msg = (err.data && (err.data.description || err.data.message)) || 'Try again';
        if (label) label.textContent = 'Try again';
        if (window.MinimogTheme && window.MinimogTheme.Notification) {
          window.MinimogTheme.Notification.show({
            target: document.body, method: 'appendChild', type: 'error',
            message: msg, last: 3000, sticky: true
          });
        }
      })
      .then(function () {
        setTimeout(function () {
          if (label) label.textContent = original;
          btn.removeAttribute('data-loading');
        }, 1200);
      });
  }

  window.__jrQuickAdd = handleQuickAdd;

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-jr-quick-add]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    handleQuickAdd(btn);
  }, true);

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-jr-form]');
    if (!form) return;
    e.preventDefault();
    handleQuickAdd(form.querySelector('[data-jr-quick-add]'));
  }, true);
})();
